var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResidents(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 8.00039C9.84065 8.00039 11.3325 6.50831 11.3325 4.66789C11.3325 2.82746 9.84065 1.33539 7.99997 1.33539C6.15928 1.33539 4.66747 2.82746 4.66747 4.66789C4.66747 6.50831 6.15928 8.00039 7.99997 8.00039ZM9.31995 9.25008H6.67998C4.18868 9.25008 2.16809 11.2704 2.16809 13.762C2.16809 14.2603 2.57216 14.6646 3.07047 14.6646H12.93C13.4283 14.6654 13.8318 14.2618 13.8318 13.762C13.8318 11.2704 11.8115 9.25008 9.31995 9.25008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidents);
export default __webpack_public_path__ + "static/media/residents.12904b7347318152dbfb5d8504c6aeda.svg";
export { ForwardRef as ReactComponent };